import { Input, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ElementRef } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  Form,
  FormElement,
  AppTableComponent,
  MessagesComponent,
  FormElementValidators,
  Auth,
  TranslationEntityComponent
} from 'src/common';
import { SupplierUserModel, SupplierUserService } from 'src/common';
import { TranslationManager } from 'src/common/translation';


@Component({
  selector: 'app-supplier-user',
  templateUrl: 'supplier-user.component.html'
})
export class SupplierUserComponent implements OnInit, AfterViewInit {

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  form: Form = new Form();
  translationManager = TranslationManager;
  @ViewChild('translationEntitySupplierUserName') translationEntitySupplierUserName: TranslationEntityComponent;

  auth = Auth;
  photoimg: string;

  fileToUpload: File = null;
  MaxFileSize: number = 1048576 * 10; // do 10 MB

  translationEntityDisplay = false;

  constructor(private router: Router, public route: ActivatedRoute, private el: ElementRef, private supplierUserService: SupplierUserService) { }



  ngAfterViewInit(): void {
    this.DisableTranslationLang();
  }

  ngOnInit(): void {
    this.initForm();
    this.form.elements['id'].value = Auth.user?.id;
    this.supplierUserService.getById(this.form.elements['id'].value).then((item: SupplierUserModel) => {
      this.bindModelToForm(item);
    }).catch((reason: any) => {
      if (reason !== null) {
        if (reason.status === 400) {
          if (reason.error !== null) {
            if (reason.error.message) {
              const mescustom = reason.error.message;
              MessagesComponent.instance.showError([mescustom]);
            }
          }
        }
      }
    });
  }


  private initForm(): void {
    this.initFormCustom();
  }

  private DisableTranslationLang(): void {
    const childNodes = document.querySelectorAll("#containerLangDetails select, #containerLangDetails input, #containerLangDetails textarea, #containerLangDetails button")[Symbol.iterator]() || null;
    if (childNodes) {
      for (var node of childNodes) {
        node.disabled = true;
      }
    }
  }

  private bindModelToForm(item: SupplierUserModel): void {
    this.form.elements['id'].value = item.id;
    this.form.elements['name'].value = item.name;
    this.form.elements['company'].value = item.company;
    this.form.elements['photo'].value = item.photo;
    if (item['translationName']) {
      this.translationEntitySupplierUserName.entity = item['translationName'];
    }

    if (item.mimeType && item.photo64Base) {
      const typeLower = item.mimeType.toLocaleLowerCase();
      const imgFormat = `data:image/${typeLower};base64,${item.photo64Base}`;
      this.photoimg = imgFormat;
    }
  }

  submit(): void {
    if (this.form.isValid() && (!this.translationEntityDisplay || this.translationEntitySupplierUserName.isValid())) {
      const model: SupplierUserModel = new SupplierUserModel();
      this.fillModel(model);
      this.supplierUserService.save(model).then(() => {
        MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно измењен ентитет')]);
        this.router.navigate(['/']);
      }).catch((reason: any) => {
        if (reason !== null) {
          if (reason.status === 400) {
            if (reason.error !== null) {
              if (reason.error.message) {
                const mescustom = reason.error.message;
                MessagesComponent.instance.showError([mescustom]);
              }
            }
          } else {
            MessagesComponent.instance.showError(reason.error.messages);
          }
        }
      });

    }
  }

  navigateToList(): void {
    this.router.navigate(['/']);
  }

  private CreateImage(photo: string, type: string) {
    if (photo && type) {
      if (type.toUpperCase() == "JFIF" || type.toUpperCase() == "JPEG" || type.toUpperCase() == "JPG" || type.toUpperCase() == "PJPEG") {
        type = "JPG";
      }
      const typeLower = type.toLocaleLowerCase();
      const imgFormat = `data:image/${typeLower};base64,${photo}`;
      this.photoimg = imgFormat;
    }
  }

  fillModel(model: SupplierUserModel) {
    model['id'] = this.form.elements['id'].value;
    model['name'] = this.form.elements['name'].value;
    model['company'] = this.form.elements['company'].value;
    model['photo'] = this.form.elements['photo'].value;

  }

  initFormCustom() {
    this.form.elements["id"] = new FormElement();
    this.form.elements["name"] = new FormElement();
    this.form.elements["company"] = new FormElement();
    this.form.elements["photo"] = new FormElement();
  }

  handleFileInput(files: FileList): void {
    this.fileToUpload = files.item(0);

    if (this.fileToUpload) {
      if (this.fileToUpload.size > this.MaxFileSize) {
        MessagesComponent.instance.showError([this.translationManager.getTranslation('Величина датотеке треба да буде мања од 10 МБ')]);
        return;
      }

      const fileext = files.item(0).name.split('?')[0].split('.').pop();
      const reader = new FileReader();
      reader.readAsArrayBuffer(this.fileToUpload);
      reader.onload = () => {
        const base64 = reader.result as ArrayBuffer;
        const attachment = new Uint8Array(base64);
        this.form.elements['photo'].value = this.arrayBufferToBase64String(attachment); //attachment;
        this.CreateImage(this.form.elements['photo'].value, fileext);
      };
    } else {
      MessagesComponent.instance.showError([this.translationManager.getTranslation('Фајл не постоји')]);
    }
  }

  arrayBufferToBase64String(buffer: ArrayBuffer): string {
    let binaryString = '';
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < bytes.byteLength; i++) {
      binaryString += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binaryString);
  }

  removePhoto() {
    this.form.elements['photo'].value = undefined;
  }
}
